import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _c(
        VRow,
        { staticClass: "justify-end", attrs: { dense: "" } },
        [
          _c(
            VTooltip,
            {
              attrs: { top: "" },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function ({ on: onTooltip }) {
                    return [
                      _c(
                        VBtn,
                        _vm._g(
                          {
                            attrs: { color: "primary" },
                            on: { click: _vm.pesquisar },
                          },
                          { ...onTooltip }
                        ),
                        [_vm._v(" Pesquisar ")]
                      ),
                    ]
                  },
                },
              ]),
            },
            [_c("span", [_vm._v("Clique para pesquisar")])]
          ),
        ],
        1
      ),
      _vm.relatorio
        ? _c(
            VCard,
            { staticClass: "mx-4", attrs: { flat: "" } },
            [
              _c(
                VRow,
                [
                  _c(
                    VCol,
                    { attrs: { cols: "12" } },
                    [_c("app-title", { attrs: { texto: "GRÁFICOS" } })],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "12" } },
                    [
                      _c("gauge-chart", {
                        staticClass: "chart",
                        attrs: {
                          dados: _vm.dadosGauge,
                          fonte: `Fonte: Sistema Desenvolva, ${_vm.anoAtual}`,
                          maximo: 100,
                          minimo: 0,
                          titulo: `Participação Geral do Perfil`,
                          descricao: "Percentual de Conclusão da(s) Unidade(s)",
                          "descricao-titulo": "Participação Geral do Perfil",
                          formato: "%",
                          "is-get-svg": _vm.isGetSvg,
                        },
                        on: { svg: (value) => (_vm.svg = value) },
                      }),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "12" } },
                    [
                      _c(VDataTable, {
                        staticClass: "elevation-0",
                        attrs: {
                          headers: _vm.tabelaUnidades.headers,
                          items: _vm.relatorio.unidades,
                          search: _vm.opcoesQuadroResumo.pesquisa,
                          "custom-filter": _vm.customFilterUnidades,
                          "sort-by": _vm.opcoesQuadroResumo.ordenarPor,
                          "sort-desc": _vm.opcoesQuadroResumo.decrescente,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "top",
                              fn: function () {
                                return [
                                  _c(
                                    VRow,
                                    { staticClass: "mb-2" },
                                    [
                                      _c(
                                        VToolbar,
                                        { attrs: { flat: "" } },
                                        [
                                          _c(VToolbarTitle, [
                                            _c(
                                              "h2",
                                              {
                                                staticClass:
                                                  "title primary--text text--darken-1 text-no-wrap",
                                              },
                                              [
                                                _vm._v(
                                                  " PARTICIPAÇÃO GERAL DO PERFIL "
                                                ),
                                              ]
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VRow,
                                    [
                                      _c(
                                        VCol,
                                        { attrs: { cols: "12", md: "4" } },
                                        [
                                          _c("app-sort", {
                                            model: {
                                              value: _vm.opcoesQuadroResumo,
                                              callback: function ($$v) {
                                                _vm.opcoesQuadroResumo = $$v
                                              },
                                              expression: "opcoesQuadroResumo",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(VSpacer),
                                      _c(
                                        VCol,
                                        { attrs: { cols: "12", md: "4" } },
                                        [
                                          _c("app-search", {
                                            model: {
                                              value: _vm.opcoesQuadroResumo,
                                              callback: function ($$v) {
                                                _vm.opcoesQuadroResumo = $$v
                                              },
                                              expression: "opcoesQuadroResumo",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: `item.percentualConclusao`,
                              fn: function ({ item }) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.calcularPctStr(
                                          item.percentualConclusao
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                            {
                              key: `body.append`,
                              fn: function () {
                                return [
                                  _c("tr", [
                                    _c(
                                      "td",
                                      {
                                        attrs: {
                                          align: "center",
                                          colspan: "2",
                                        },
                                      },
                                      [
                                        _c(
                                          "strong",
                                          {
                                            staticClass:
                                              "subtitle-2 grey--text text--darken-2",
                                          },
                                          [_vm._v("TOTAL")]
                                        ),
                                      ]
                                    ),
                                    _c("td", { attrs: { align: "center" } }, [
                                      _c("strong", [
                                        _vm._v(_vm._s(_vm.total.servidores)),
                                      ]),
                                    ]),
                                    _c("td", { attrs: { align: "center" } }, [
                                      _c("strong", [
                                        _vm._v(_vm._s(_vm.total.pendentes)),
                                      ]),
                                    ]),
                                    _c("td", { attrs: { align: "center" } }, [
                                      _c("strong", [
                                        _vm._v(_vm._s(_vm.total.concluidos)),
                                      ]),
                                    ]),
                                    _c("td", { attrs: { align: "center" } }, [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("decimal")(
                                              _vm.total.percentual
                                            )
                                          ) + " %"
                                        ),
                                      ]),
                                    ]),
                                  ]),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "12" } },
                    [
                      _c(VDataTable, {
                        staticClass: "elevation-0",
                        attrs: {
                          headers: _vm.tabelaResultados.headers,
                          items: _vm.relatorio.servidores,
                          search: _vm.opcoesResultados.pesquisa,
                          "custom-filter": _vm.customFilterServidores,
                          "sort-by": _vm.opcoesResultados.ordenarPor,
                          "sort-desc": _vm.opcoesResultados.decrescente,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "top",
                              fn: function () {
                                return [
                                  _c(
                                    VRow,
                                    { staticClass: "mb-2" },
                                    [
                                      _c(
                                        VToolbar,
                                        { attrs: { flat: "" } },
                                        [
                                          _c(VToolbarTitle, [
                                            _c(
                                              "h2",
                                              {
                                                staticClass:
                                                  "title primary--text text--darken-1 text-no-wrap",
                                              },
                                              [_vm._v(" RESULTADOS ")]
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VRow,
                                    [
                                      _c(
                                        VCol,
                                        { attrs: { cols: "12", md: "4" } },
                                        [
                                          _c("app-sort", {
                                            model: {
                                              value: _vm.opcoesResultados,
                                              callback: function ($$v) {
                                                _vm.opcoesResultados = $$v
                                              },
                                              expression: "opcoesResultados",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(VSpacer),
                                      _c(
                                        VCol,
                                        { attrs: { cols: "12", md: "4" } },
                                        [
                                          _c("app-search", {
                                            model: {
                                              value: _vm.opcoesResultados,
                                              callback: function ($$v) {
                                                _vm.opcoesResultados = $$v
                                              },
                                              expression: "opcoesResultados",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: `item.cadastro`,
                              fn: function ({ item }) {
                                return [
                                  _c(VIcon, { attrs: { color: "grey" } }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          `${_vm.getIcone(item.isCadastroOk)}`
                                        ) +
                                        " "
                                    ),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: `item.formacao`,
                              fn: function ({ item }) {
                                return [
                                  _c(VIcon, { attrs: { color: "grey" } }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          `${_vm.getIcone(item.isFormacaoOk)}`
                                        ) +
                                        " "
                                    ),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: `item.atuacaoProfissional`,
                              fn: function ({ item }) {
                                return [
                                  _c(VIcon, { attrs: { color: "grey" } }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          `${_vm.getIcone(
                                            item.isAtuacaoProfissionalOk
                                          )}`
                                        ) +
                                        " "
                                    ),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: `item.atividadesInteresse`,
                              fn: function ({ item }) {
                                return [
                                  _c(VIcon, { attrs: { color: "grey" } }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          `${_vm.getIcone(
                                            item.isAtividadesDeInteresseOk
                                          )}`
                                        ) +
                                        " "
                                    ),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: `item.preferenciasTrabalho`,
                              fn: function ({ item }) {
                                return [
                                  _c(VIcon, { attrs: { color: "grey" } }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          `${_vm.getIcone(
                                            item.isPreferenciasDeTrabalhoOk
                                          )}`
                                        ) +
                                        " "
                                    ),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: `item.situacao`,
                              fn: function ({ item }) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        item.isConcluido
                                          ? "CONCLUÍDO"
                                          : "PENDENTE"
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                VRow,
                { staticClass: "justify-end mb-1" },
                [
                  _c(
                    VTooltip,
                    {
                      attrs: { "max-width": "400", top: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function ({ on }) {
                              return [
                                _c(
                                  VBtn,
                                  _vm._g(
                                    {
                                      attrs: { color: "success" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.getRelatorio()
                                        },
                                      },
                                    },
                                    on
                                  ),
                                  [
                                    _c(VIcon, [_vm._v("get_app")]),
                                    _vm._v(" BAIXAR PDF "),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3755186528
                      ),
                    },
                    [
                      _c("span", [
                        _vm._v(
                          "Clique para baixar o relatório dos dados em formato PDF."
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }